import http from "./http";

export const fetchEcpAuth = (payload) => {
  // return http.post("/parent/ecp-auth");
  return http.post("/landing/parent/ecp-auth", payload);
};
